import GenericForm from './GenericFormFailInner';

export default GenericForm;
